import React from 'react';
import Certificate from "../../../components/pages/grid/Certificate/Certificate";

const CertificateGridPage = () => {
    return <Certificate />
};

export default CertificateGridPage;
